import { MainLayout } from 'layouts'
import { LkmRegionList } from './components/LkmRegionList/LkmRegionList'

export function LkmRegionPage() {
  return (
    <MainLayout>
      <div className='container'>
        <h1>Регионы обслуживания</h1>
        <LkmRegionList />
      </div>
    </MainLayout>
  )
}
